import React, { useEffect } from 'react'
import ReactGA from 'react-ga'
import { AiOutlineDownload } from 'react-icons/ai'
import { MdWork, MdSchool, MdVerified } from 'react-icons/md'
import pdf from '../../Assets/myresume.pdf'

function Resume() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search)
  }, [])

  return (
    <div style={{ paddingTop: '100px', background: 'var(--bg)', minHeight: '100vh' }}>
      <div className="section">
        <div className="section-inner">
          <div className="section-tag">resume</div>
          <h1 className="section-title">Experience &amp; <span>Education</span></h1>

          <a href={pdf} target="_blank" rel="noreferrer" className="resume-download-btn" style={{ marginBottom: '48px', display: 'inline-flex' }}>
            <AiOutlineDownload /> Download CV
          </a>

          <div className="resume-grid">
            <div>
              <div className="resume-col-title"><MdWork /> Experience</div>

              <div className="resume-item-new">
                <div className="resume-item-title">AI ML Python Developer — AeonX Digital Solutions</div>
                <span className="resume-item-date">August 2023 – Present</span>
                <ul className="resume-item-list">
                  <li>Implemented AWS cloud services: S3, QuickSight, Bedrock, RDS, AmazonMQ, DynamoDB.</li>
                  <li>Developed automated model training and production management system for Konark Industries using Raspberry Pi and Machine Vision cameras.</li>
                  <li>Collected real-time CNC machine data for Maini Industries via OPC server, stored on cloud, visualised via AWS QuickSight.</li>
                  <li>Built multi-tenant machine vision SaaS for Sunder Biscuit with IoT gateways, PLCs, and end-to-end cloud integration.</li>
                </ul>
              </div>

              <div className="resume-item-new">
                <div className="resume-item-title">Trainee AI ML Developer — Innovative Engineers</div>
                <span className="resume-item-date">June 2023 – August 2023</span>
                <ul className="resume-item-list">
                  <li>Learned ML and Deep Learning concepts, algorithms and frameworks.</li>
                  <li>Developed AI ML model for audio and spectrum analysis.</li>
                </ul>
              </div>

              <div className="resume-item-new">
                <div className="resume-item-title">Intern Software &amp; Web Developer — Digital Sky 360</div>
                <span className="resume-item-date">Feb 2022 – March 2022</span>
                <ul className="resume-item-list">
                  <li>Learned Python frameworks and Core JavaScript with HTML5 and CSS.</li>
                  <li>Designed and developed various client websites.</li>
                </ul>
              </div>
            </div>

            <div>
              <div className="resume-col-title"><MdSchool /> Education</div>

              <div className="resume-item-new">
                <div className="resume-item-title">MSc Bioinformatics</div>
                <span className="resume-item-date">2021 – 2023</span>
                <ul className="resume-item-list">
                  <li>Gujarat University, Ahmedabad.</li>
                </ul>
              </div>

              <div className="resume-item-new">
                <div className="resume-item-title">BSc Biotechnology</div>
                <span className="resume-item-date">2018 – 2021</span>
                <ul className="resume-item-list">
                  <li>President Science College, Ahmedabad — affiliated to Gujarat University.</li>
                </ul>
              </div>

              <div className="resume-col-title" style={{ marginTop: '32px' }}><MdVerified /> Certifications</div>

              <div className="resume-item-new">
                <ul className="resume-item-list">
                  <li>Claude Certified Architect — Foundation</li>
                  <li>Associate Google Cloud Engineer</li>
                  <li>GitHub Foundations</li>
                  <li>Python Programming &amp; Web Development — TCS Ion</li>
                  <li>Data Science &amp; Machine Learning — Acmegrade</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Resume
